import { useEffect, useState } from "react";
import Table from "../components/Table";
import Modal from "../components/Modal";
import Form from "../components/Form";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
const ESTADO_INICIAL = { id: null, nombre: '' };

export default function SucursalesScreen({ currentUser, token }) {
  const [sucursales, setSucursales] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showForm, setShowForm]     = useState(false);
  const [sucursalForm, setSucursalForm] = useState(ESTADO_INICIAL);
  const [modal, setModal] = useState({ visible: false, titulo: '', mensaje: '', tipo: 'info', onConfirm: null });

  const isAdmin   = currentUser?.rol === 'admin';
  const showModal = (tipo, titulo, mensaje, onConfirm = null) =>
    setModal({ visible: true, tipo, titulo, mensaje, onConfirm });
  const set = (campo) => (v) => setSucursalForm(f => ({ ...f, [campo]: v }));

  const cargar = async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API_URL}/sucursales`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json().catch(() => []);
      setSucursales(Array.isArray(data) ? data : []);
    } catch {
      showModal('error', 'Error', 'No se pudieron cargar las sucursales');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo  = () => { setSucursalForm(ESTADO_INICIAL); setShowForm(true); };
  const abrirEditar = (row) => { setSucursalForm({ id: row.id, nombre: row.nombre }); setShowForm(true); };
  const cerrarForm  = () => { setShowForm(false); setSucursalForm(ESTADO_INICIAL); };

  const handleGuardar = async (e) => {
    e.preventDefault();
    try {
      const esEdicion = !!sucursalForm.id;
      const res = await fetch(
        esEdicion ? `${API_URL}/sucursales/${sucursalForm.id}` : `${API_URL}/sucursales`,
        {
          method: esEdicion ? 'PUT' : 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ nombre: sucursalForm.nombre })
        }
      );
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message);
      cerrarForm();
      cargar();
      showModal('success', 'Listo', esEdicion ? 'Sucursal actualizada' : 'Sucursal creada');
    } catch (err) {
      showModal('error', 'Error', err.message);
    }
  };

  const columnas = [
    { header: 'ID',     accessor: 'id' },
    { header: 'Nombre', accessor: 'nombre' },
    ...(isAdmin ? [{
      header: 'Acciones', render: (row) => (
        <button className="btn-edit" onClick={() => abrirEditar(row)}>Editar</button>
      )
    }] : []),
  ];

  const campos = [
    { label: 'Nombre', value: sucursalForm.nombre, onChange: set('nombre'), required: true, placeholder: 'Nombre de la sucursal' },
  ];

  if (loading) return <p>Cargando...</p>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0 }}>Sucursales</h2>
        {isAdmin && (
          <button className="btn-primary" onClick={showForm ? cerrarForm : abrirNuevo}>
            {showForm ? 'Cancelar' : '+ Nueva Sucursal'}
          </button>
        )}
      </div>

      {showForm && (
        <Form campos={campos} onSubmit={handleGuardar} onCancel={cerrarForm}
          submitLabel={sucursalForm.id ? 'Actualizar' : 'Crear'} />
      )}

      <Table columnas={columnas} datos={sucursales} mensajeVacio="Sin sucursales registradas" />
      <Modal modal={modal} setModal={setModal} />
    </div>
  );
}